import React from 'react'
import { Text } from '@mindfulchefuk/design-system'

type Props = {
  allergens: string[]
  possibleAllergens: string[]
}

export const RecipeAllergens = ({ allergens, possibleAllergens }: Props) => {
  if (!allergens.length && !possibleAllergens.length)
    return <Text variant="body-lg">None</Text>
  return (
    <>
      {!!allergens.length && (
        <Text variant="body-lg">
          Contains:
          <Text variant="body-lg-500" as="span">
            {' '}
            {allergens.join(', ')}
          </Text>
        </Text>
      )}
      {!!possibleAllergens.length && (
        <Text variant="body-lg">
          May contain:
          <Text variant="body-lg-500" as="span">
            {' '}
            {possibleAllergens.join(', ')}
          </Text>
        </Text>
      )}
    </>
  )
}
